import React, { useEffect } from 'react';
import BaseModal from 'app_previous/molecules/Shared/BaseModal/BaseModal';
import {
  PricingQuizIframe,
  PricingQuizIframeContainer,
  PricingQuizLayout,
  PricingQuizPadding,
} from './PricingQuizModal.styles';
import { getLocalStorage, setLocalStorage } from 'src/functions/localStorageHandler';
import { QUIZ_IFRAME_INTERACTION_STORAGE_KEY } from 'src/hooks/usePricingQuizModalController';

interface PricingQuizModalProps {
  isVisible: boolean;
  closeQuiz?: () => void;
  skipIntro?: boolean;
}

const QUIZ_SKIPPING_INTRO_ID = '66b136f22085c70015c1177d';
const QUIZ_WITH_INTRO_ID = '67215ba1c666610015984b3d';

const PricingQuizModal = ({ isVisible, closeQuiz, skipIntro = true }: PricingQuizModalProps): JSX.Element => {
  const trackInteractionWithQuizIframe = (): void => {
    if (document.activeElement instanceof HTMLIFrameElement) {
      const hasInteracted = getLocalStorage(QUIZ_IFRAME_INTERACTION_STORAGE_KEY);

      if (hasInteracted === 'true') return;

      setLocalStorage(QUIZ_IFRAME_INTERACTION_STORAGE_KEY, 'true');
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('blur', trackInteractionWithQuizIframe);
  }, []);

  const quizId = skipIntro ? QUIZ_SKIPPING_INTRO_ID : QUIZ_WITH_INTRO_ID;
  const quizUrl = `https://quiz.tryinteract.com/#/${quizId}${skipIntro ? '/q/1' : ''}?method=iframe`;

  return (
    <BaseModal
      isVisible={isVisible}
      handleClose={closeQuiz}
      width={600}
      hideCloseButton
      key={quizId}
    >
      <PricingQuizPadding>
        <PricingQuizLayout>
          <PricingQuizIframeContainer>
            <PricingQuizIframe
              id={`interactApp${quizId}`}
              width='100%'
              height='100%'
              allow-transparency='true'
              frame-border='0'
              src={quizUrl}
            />
          </PricingQuizIframeContainer>
        </PricingQuizLayout>
      </PricingQuizPadding>
    </BaseModal>
  );
};

export default PricingQuizModal;
